import { CHANGE_LANG } from "../types";

export const changeLang = (locale) => ({
  type: CHANGE_LANG,
  locale,
});
